import React, { useEffect, useRef, useState } from "react";
import { ArrowDown, ArrowUp } from "react-bootstrap-icons";
import Sidebar from "../components/sideBar";
import Header from "../components/header";

// how far (px) from the top/bottom before the matching button shows
const SCROLL_THRESHOLD = 200;

function Layout({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const scrollRef = useRef(null);
  const [canScroll, setCanScroll] = useState({ up: false, down: false });

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const updateCanScroll = () => {
      setCanScroll({
        up: el.scrollTop > SCROLL_THRESHOLD,
        down:
          el.scrollTop + el.clientHeight < el.scrollHeight - SCROLL_THRESHOLD,
      });
    };

    updateCanScroll();
    el.addEventListener("scroll", updateCanScroll);
    // page content grows/shrinks without scrolling (e.g. "Add New Form")
    const resizeObserver = new ResizeObserver(updateCanScroll);
    resizeObserver.observe(el);
    Array.from(el.children).forEach((child) => resizeObserver.observe(child));

    return () => {
      el.removeEventListener("scroll", updateCanScroll);
      resizeObserver.disconnect();
    };
  }, [children]);

  const scrollTo = (top) => {
    scrollRef.current?.scrollTo({ top, behavior: "smooth" });
  };

  return (
    <div className="flex w-[100%]">
      <div>
        <Sidebar isOpen={isOpen} setIsOpen={setIsOpen}  />
      </div>
      <div  className=" h-full w-full">
        {/* <div>
          <Header />
        </div> */}
        <div ref={scrollRef} style={{height:"100vh",overflow:'scroll'}} className={isOpen ? "ml-[15rem]": " ml-[5rem]"}>{children}</div>
      </div>

      <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-2">
        {canScroll.up && (
          <button
            type="button"
            title="Scroll to top"
            onClick={() => scrollTo(0)}
            className="p-3 rounded-full bg-gray-800 text-white shadow-lg hover:bg-gray-700"
          >
            <ArrowUp size={18} />
          </button>
        )}
        {canScroll.down && (
          <button
            type="button"
            title="Scroll to bottom"
            onClick={() => scrollTo(scrollRef.current?.scrollHeight)}
            className="p-3 rounded-full bg-gray-800 text-white shadow-lg hover:bg-gray-700"
          >
            <ArrowDown size={18} />
          </button>
        )}
      </div>
    </div>
  );
}

export default Layout;
